import React from "react";

import styles from './DownloadButton.module.css'

type variant = "primary" | "outline";
export type size = "lg" | "sm";

type TDownloadButton = {
  variant: variant,
  size: size,
  onClick?: () => void,
  platform?: string,
  fileName?: string,
  text: string,
  setCurrentFileName?: React.Dispatch<React.SetStateAction<string>>
}

const DownloadButton: React.FC<TDownloadButton> = ({ setCurrentFileName, fileName, platform, text, variant, size, onClick }) => {
  const handleClick = () => {
    onClick && onClick();
    setCurrentFileName && setCurrentFileName(fileName ? fileName : '');
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={`${styles.button} ${styles[variant]} ${styles[size]}`}
      >
        <span className={styles.overflow}>{text}</span>
      </button>
    </>
  );
};

export default DownloadButton;